module.exports = __webpack_public_path__ + "static/media/dmt1.17c4cf90.png";